import React, { createContext, useContext, useReducer } from "react";

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

const reducer = (state, action) => {
  switch (action.type) {
    case "ADD":
      const exist = state.find((i) => i.sid === action.payload.sid);
      if (exist) {
        return state.map((i) =>
          i.sid === action.payload.sid
            ? { ...i, qty: i.qty + 1 }
            : i
        );
      }
      return [...state, { ...action.payload, qty: 1 }];

    case "REMOVE":
      return state.filter((i) => i.sid !== action.payload);

    case "DECREASE":
      return state.map((i) =>
        i.sid === action.payload
          ? { ...i, qty: i.qty > 1 ? i.qty - 1 : 1 }
          : i
      );

    default:
      return state;
  }
};

export const CartProvider = ({ children }) => {
  const [cart, dispatch] = useReducer(reducer, []);

  return (
    <CartContext.Provider value={{ cart, dispatch }}>
      {children}
    </CartContext.Provider>
  );
};
